import { useCallback, useEffect, useState } from 'react';
import type { ApiClient } from '../../api/client';

type Project = { app_id: string; name: string; enabled: boolean; session_key: string | null };
export default function ProjectChats({ apiClient }: { apiClient: ApiClient }) {
  const [projects, setProjects] = useState<Project[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState<string | null>(null);
  const refresh = useCallback(async () => {
    const value = await apiClient.get<{ projects: Project[] }>('/api/assistant/gateway/projects');
    setProjects(value.projects);
  }, [apiClient]);
  useEffect(() => { void refresh().catch(() => setError('Project chats could not be loaded.')); }, [refresh]);
  async function toggle(project: Project) {
    setBusy(project.app_id); setError(null);
    try {
      await apiClient.post('/api/assistant/gateway/projects', { app_id: project.app_id, enabled: !project.enabled });
      await refresh();
    } catch { setError('The project setting could not be confirmed. Refresh before trying again.'); }
    finally { setBusy(null); }
  }
  return <section className="personal-gateway-card" aria-labelledby="assistant-projects-title">
    <h2 id="assistant-projects-title">Project chats</h2>
    <p>Choose which projects appear in your OpenClaw app. Each has a separate assistant chat and read-only views of your coding conversations. The assistant still asks before reading private contents or starting work.</p>
    {projects.length ? <ul className="assistant-mobile-list">{projects.map(project => <li key={project.app_id}>
      <div><strong>{project.name}</strong><span>{project.enabled ? 'Visible in OpenClaw' : 'Hidden from OpenClaw'}</span></div>
      <button className="secondary" disabled={!!busy} aria-pressed={project.enabled} onClick={() => { void toggle(project); }}>{busy === project.app_id ? 'Saving…' : project.enabled ? 'Hide' : 'Enable'}</button>
    </li>)}</ul> : <p>No accessible projects were found.</p>}
    {error && <p role="alert">{error}</p>}
  </section>;
}
